import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, GetGoalActivitySchema, WeeklyActivityResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof WeeklyActivityResponseDataSchema>>

const getGoalsActivityQueryKey = (params: Params) => ["goals", JSON.stringify(params), "activity"]

type Params = z.input<typeof GetGoalActivitySchema>

type Props = {
  params: Params
  enabled?: boolean
}

export const goalsActivityQuery = ({ params, enabled }: Props) => {
  return queryOptions({
    queryKey: getGoalsActivityQueryKey(params),
    queryFn: async () => {
      const response = await axios.get<Response>(`/goals/activity`, { params })
      return response.data.data
    },
    staleTime: 1000 * 60 * 2,
    enabled,
  })
}
